import React from "react";
import { Form } from "./form";
import { FormV2 } from "./formV2";


export const LoginForm = ({showV2 = false, ...props}: any) => {

  if(showV2) {
    return <FormV2 {...props}/>;
  }

  return <Form {...props}/>;
};
